if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.handleClickOnSubmit.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.productCardWrapper = this.closest('.js-product-card-wrapper');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      handleClickOnSubmit(evt) {
        evt.preventDefault();

        this.productCardWrapper?.classList.add('active-form');
        this.variantRadios = this.closest('.product')?.querySelector('variant-radios');
        this.dropdownSelect = this.closest('.product')?.querySelector('dropdown-selects');

        if (this.submitButton.dataset.hasVariants) {
          // Product card case: Open the size selector dropdown if the product has variants
          evt.stopImmediatePropagation();
          this.onOpenVariantSelector();
        } else if (this.variantRadios && !this.variantRadios.hasAttribute('selected')) {
          // PDP case when no size is selected
          evt.stopImmediatePropagation();
          if (this.closest('.appears-sticky') || this.closest('.floating-add-to-cart')) {
            // If in sticky buy bar -- show size selector
            this.dropdownSelect?.click();
            // Define the handler as a bound method
            this.boundVariantChangeHandler = this.onSubmitHandler.bind(this);
            this.variantRadios.addEventListener('variant:changed', this.boundVariantChangeHandler);
          } else {
            // Show an error if no size is selected
            this.variantRadios.setAttribute('has-error', '');
          }
        } else {
          // otherwise proceed with form submission
          this.onSubmitHandler();
        }
      }

      onOpenVariantSelector() {
        this.initializeElements();
        this.showVariantSelector();

        document.addEventListener('click', this.handleDocumentClick.bind(this));
        this.closeBtn.addEventListener('click', () => {
          this.productCardWrapper?.classList.remove('active-form');
          this.hideVariantSelector();
        });
        this.variantOptions.forEach((option) => {
          if (option.classList.contains('sold-out')) return;
          option.addEventListener('click', this.handleOptionClick.bind(this));
        });
      }

      initializeElements() {
        this.variantSelector = this.productCardWrapper.querySelector('.variant-selector');
        this.cardElement = this.productCardWrapper.querySelector('.card--card');
        this.closeBtn = this.variantSelector.querySelector('.selector__close');
        this.variantOptions = this.variantSelector.querySelectorAll('.selector__menu > li');
        this.productFormVariantInput = this.productCardWrapper.querySelector('.product-variant-id');
        this.bodyLayer = document.querySelector('.body-layer');
      }

      showVariantSelector() {
        this.variantSelector.classList.remove('hidden');
        if (!this.querySelector('.submit-message')?.classList.contains('hidden')) {
          this.handleStateClearAfterSubmit();
        }

        if (window.innerWidth < 990) {
          document.body.appendChild(this.variantSelector);
          this.bodyLayer.classList.remove('hidden');
        }
      }

      handleDocumentClick(event) {
        if (!this.variantSelector.contains(event.target) && !event.target.closest('dropdown-selects-options')) {
          this.productCardWrapper?.classList.remove('active-form');
          this.hideVariantSelector();
        }
      }

      handleOptionClick(event) {
        this.productFormVariantInput.value = event.target.dataset.variantId;
        this.onSubmitHandler(event);
        this.hideVariantSelector();
      }

      hideVariantSelector() {
        this.variantSelector.classList.add('hidden');
        if (window.innerWidth < 990) {
          this.cardElement.appendChild(this.variantSelector);
          this.bodyLayer.classList.add('hidden');
        }
      }

      handleStateClearAfterSubmit() {
        this.querySelector('.submit-message')?.classList.add('hidden');
        this.querySelector('.default-message')?.classList.remove('hidden');
        this.submitButton.classList.remove('loading-bg-color');
      }

      onSubmitHandler() {
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading', 'loading-bg-color');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
                isPdpProductAdded: Boolean(this.closest('product-info')),
                isRecoCardAdded: Boolean(this.closest('exponea-reco')),
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');

            this.querySelector('.submit-message')?.classList.remove('hidden');
            this.querySelector('.default-message')?.classList.add('hidden');
            setTimeout(() => {
              this.handleStateClearAfterSubmit();
              this.productCardWrapper?.classList.remove('active-form');
            }, 5000);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
